import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SchemaOrg from "@/components/base/SchemaOrg";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SchemaOrg
          data={{
            '@type': 'WebSite',
            name: 'Hipobuy Spreadsheet',
            url: 'https://hipobuyspread.casa/',
            description: 'The most complete organized shopping spreadsheet resource hub. Discover curated product databases, verified category guides, and comparison tools.',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://hipobuyspread.casa/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }}
        />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;